import React from 'react';
import DocumentTitle from 'react-document-title';
import { Progress, Alert } from 'antd';
import { connect } from 'dva';
import { setAuthority } from 'utils/authority.js';
import qs from 'qs';
import styles from './XiaoYuanHaoAuthorizeLayout.less';

@connect()
export default class XiaoYuanHaoAuthorizeLayout extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      percent: 0,
      interval: 25,
      status: 'active',
      response: null,
    };

    this.searchParams = qs.parse(window.location.search.slice(1));

    this.increment = this.increment.bind(this);
  }

  componentDidMount() {
    this.increment();

    this.props
      .dispatch({ type: 'user/authXiaoYuanHaoLogin' })
      .then(() => {
        setTimeout(() => {
          this.setState({ status: 'success' });
          this.increment();
        }, 500);
      })
      .catch(err => {
        setTimeout(() => {
          this.setState({
            status: 'exception',
            response: err,
          });
        }, 500);
      });
  }

  increment() {
    const { percent, status } = this.state;

    window.setTimeout(() => {
      if (status === 'active' && percent < 100) {
        this.setState({
          percent: percent + 1,
        });

        this.increment();
      } else if (status === 'success') {
        this.setState({
          percent: 100,
        });

        setTimeout(() => {
          setAuthority('admin');
          const { redirect } = this.searchParams;
          if (redirect) {
            location.replace(redirect);
          } else {
            location.replace('/');
          }
        }, 500);
      } else if (status === 'exception') {
        this.setState({
          percent: 100,
        });
      }
    }, this.state.interval);
  }

  render() {
    const { status, percent, response } = this.state;

    return (
      <DocumentTitle title="校之付-授权">
        <div className={styles.root}>
          <Progress type="circle" status={status} percent={percent} />
          {status === 'active' && <Alert message="授权中……" />}
          {status === 'success' && <Alert type="success" message="授权成功，跳转中……" />}
          {status === 'exception' && <Alert type="error" message={`授权失败：${response.msg}`} />}
        </div>
      </DocumentTitle>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/XiaoYuanHaoAuthorizeLayout.js